<template>
  <div class="ttshop_user">
    <Header></Header>
    <Userheader></Userheader>
    <div class="ttshop_user">
      <div class="ttshop_usercon w clearfloat">
        <div class="ttshop_accountrightcon">
          <div class="ttshop_accounav">
            <ul class="clearfloat">
              <li class="active">
                <h6>1</h6>
                <span>验证身份</span>
              </li>
              <li>
                <h6>2</h6>
                <span>修改密码</span>
              </li>
              <li>
                <h6>3</h6>
                <span>修改成功</span>
              </li>
            </ul>
          </div>

          <div class="ttshop_accounconter">
            <!-- 验证身份 -->
            <div class="ttshop_accounlist" v-if="!amend">
              <ul>
                <li class="clearfloat">
                  <p>手机号：</p>
                  <span>{{ binding }}</span>
                </li>
                <li>
                  <!-- <input type="text" placeholder="请输入手机短信验证码">
									<button class="ttshop_huoqu">获取验证码</button> -->
                  <input
                    type="text"
                    v-model="mobileCode"
                    ref="mobileCode"
                    placeholder="手机验证码"
                    class="ttshop_mobileyz"
                    autocomplete="new-password"
                  />
                  <template v-if="show">
                    <div
                      class="
                        ttshop_yzm
                        d-flex
                        align-items-center
                        justify-content-center
                      "
                      v-if="success"
                      @click="getCode"
                    >
                      获取验证码
                    </div>
                    <div
                      class="
                        ttshop_yzm
                        d-flex
                        align-items-center
                        justify-content-center
                      "
                      v-else
                    >
                      获取验证码
                    </div>
                  </template>
                  <template v-if="!show">
                    <div
                      class="
                        ttshop_yzm
                        d-flex
                        align-items-center
                        justify-content-center
                      "
                    >
                      {{ count }}秒后重新发送
                    </div>
                  </template>
                </li>
                <li>
                  <button class="ttshop_accounnext" @click="nextstep">
                    下一步
                  </button>
                </li>
                <!-- <li>
									<div class="ttshop_email">选择邮箱验证方式 ></div>
								</li> -->
              </ul>
            </div>
            <!-- 修改密码 -->
            <div class="ttshop_accounconed" v-if="amend">
              <ul>
                <li class="clearfloat">
                  <p>登录名：</p>
                  <span>{{ binding }}</span>
                </li>
                <li class="clearfloat">
                  <p class="ttshop_accountext">新密码：</p>
                  <input
                    type="text"
                    placeholder="6-20个字符，由字母、数字和符号的两种以上组合"
                    v-model="newpassword"
                  />
                </li>
                <li class="clearfloat">
                  <p class="ttshop_accountext">确认密码：</p>
                  <input
                    type="text"
                    placeholder="请再次输入新密码"
                    v-model="verifypassword"
                  />
                </li>
                <li class="clearfloat">
                  <button class="ttshop_accounnext" @click="forward">
                    下一步
                  </button>
                </li>
              </ul>
            </div>
            <!-- 修改成功 -->
            <div class="ttshop_accounseccess" style="display: none">
              <div class="ttshop_accounseccessimg">
                <img
                  class="img-default"
                  src="../../assets/images/ttshop_success.png"
                  alt=""
                />
              </div>
              <span>修改密码成功，请牢记新的登录密码</span>
              <p>返回个人中心</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import Header from "@/components/header/header";
import Foot from "@/components/foot/foot";
import Userheader from "./components/user_index";
import { Base64 } from "js-base64";
import md5 from "js-md5";
export default {
  components: {
    Header,
    Userheader,
    Foot,
  },
  data() {
    return {
      binding: "",
      mobileCode: "",
      show: true,
      success: true,
      timer: null,
      count: "",
      user_info: "",
      amend: false,
      newpassword: "", //新密码
      verifypassword: "", //确认密码
    };
  },
  created() {
    this.user_info = this.$store.state.user;
    let user = this.$store.state.user;
    let binding = user.binding;
    this.binding = binding.substr(0, 3) + "****" + binding.substr(7);
  },
  mounted() {},
  methods: {
    continue() {},
    // 确认密码的下一步
    forward() {
      if (this.newpassword == "") {
        this.$message({
          type: "warning",
          message: res.msg,
          showClose: true,
          offset: 200,
          duration: 1000,
        });
        return false;
      }
      if (this.verifypassword == "") {
        this.$message({
          type: "warning",
          message: '请输入密码',
          showClose: true,
          offset: 200,
          duration: 1000,
        });
        return false;
      }
	  if(this.newpassword!=this.verifypassword){
		  this.$message({
          type: "warning",
          message: '请输入一样的密码',
          showClose: true,
          offset: 200,
          duration: 1000,
        });
        return false;
	  }
	  
    },
    //   下一步
    nextstep() {
      this.amend = false;
    },
    // 获取验证码
    getCode() {
      this.resSale();
    },
    //获取验证码
    resSale() {
      let _this = this;
      let phone_number = this.user_info.binding;
      var time = Date.parse(new Date()) / 1000;
      this.dateFormat("y*m=dh&i#s", new Date());
      console.log(this.formatStr);
      var date = _this.formatStr;
      var first = phone_number.substr(1, 4);
      var end = phone_number.substr(phone_number.length - 4);
      var sign = Base64.encode(md5(first + date + end + phone_number + time));
      _this.$api
        .resSale({
          mobile: phone_number,
          sign_time: time,
          sign: sign,
        })
        .then((res) => {
          _this.$api
            .sendCode({
              mobile: phone_number,
              token: res.data.token,
            })
            .then((res) => {
              const TIME_COUNT = 60;
              if (!_this.timer) {
                _this.count = TIME_COUNT;
                _this.show = false;
                _this.timer = setInterval(() => {
                  if (_this.count > 0 && _this.count <= TIME_COUNT) {
                    _this.count--;
                  } else {
                    _this.show = true;
                    clearInterval(this.timer);
                    _this.timer = null;
                  }
                }, 1000);
              }
            })
            .catch((err) => {
              _this.common.message(this, err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    dateFormat(formatStr, fdate) {
      var fTime,
        fStr = "ymdhis";
      if (!formatStr) formatStr = "y/m/d-h:i:s";
      if (fdate) {
        fTime = new Date(fdate);
      } else {
        fTime = new Date();
      }
      var formatArr = [
        fTime.getFullYear().toString(),
        (fTime.getMonth() + 1).toString() < 10
          ? "0" + (fTime.getMonth() + 1).toString()
          : (fTime.getMonth() + 1).toString(),
        fTime.getDate().toString() < 10
          ? "0" + fTime.getDate().toString()
          : fTime.getDate().toString(),
        fTime.getHours().toString() < 10
          ? "0" + fTime.getHours().toString()
          : fTime.getHours().toString(),
        fTime.getMinutes().toString() < 10
          ? "0" + fTime.getMinutes().toString()
          : fTime.getMinutes().toString(),
        fTime.getSeconds().toString() < 10
          ? "0" + fTime.getSeconds().toString()
          : fTime.getSeconds().toString(),
      ];
      for (var i = 0; i < formatArr.length; i++) {
        formatStr = formatStr.replace(fStr.charAt(i), formatArr[i]);
      }
      this.formatStr = formatStr;
    },
    //退出
    signout() {
      this.fullscreenLoading=true;
      this.common.signout(this);
    },
  },
};
</script>

<style  lang="scss" scoped>
.ttshop_accountrightcon {
  width: 990px;
  margin: 0 auto;
  min-height: 537px;
  background: #fff;
  padding: 20px 56px;
  box-sizing: border-box;
  .ttshop_accounav {
    width: 100%;
    border-bottom: 1px solid #ebebeb;
    ul {
      display: table;
      margin: 0 auto;
      li {
        float: left;
        padding: 20px 0 16px 0;
        box-sizing: border-box;
        margin-right: 56px;
        position: relative;
        &:last-child {
          margin-right: 0;
        }
        h6 {
          display: inline-block;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          background: #ebebeb;
          text-align: center;
          line-height: 24px;
          font-size: 14px;
          color: #999;
          font-weight: 400;
          margin-right: 12px;
        }
        span {
          font-size: 12px;
          color: #999;
        }
        &::before {
          content: "";
          width: 0%;
          height: 1px;
          background: #ff9010;
          position: absolute;
          bottom: -1px;
          left: 0;
        }
        &.active::before {
          width: 100%;
        }
        &.active h6 {
          background: #ff9010;
          color: #fff;
        }
        &.active span {
          color: #ff9010;
        }
      }
    }
  }
  .ttshop_accounconter {
    width: 100%;
    .ttshop_accounlist {
      width: 380px;
      margin: 0 auto;
      padding-top: 90px;
      box-sizing: border-box;
      ul {
        li {
          width: 100%;
          margin-bottom: 20px;
          position: relative;
          p {
            float: left;
            font-size: 12px;
            color: #333;
          }
          span {
            float: left;
            font-size: 12px;
            color: #333;
          }
          input {
            width: 100%;
            height: 40px;
            border: 1px solid #ebebeb;
            outline: none;
            padding-left: 41px;
            padding-right: 110px;
            box-sizing: border-box;
            font-size: 12px;
            color: #333;
            border-radius: 2px;
            margin-bottom: 20px;
            transition: 0.5s;
            -moz-transition: 0.5s;
            -webkit-transition: 0.5s;
            -o-transition: 0.5s;
            background: url(../../assets/images/ttshop_xinxi.png) 13px center
              no-repeat;
            &:focus {
              border-color: #ff0e25;
            }
          }
          .ttshop_huoqu {
            position: absolute;
            top: 1px;
            right: 1px;
            min-width: 109px;
            height: 38px;
            border: 0;
            font-size: 12px;
            color: #333;
            background: #ebebeb;
            outline: none;
            border-radius: 0 2px 2px 0;
            cursor: pointer;
          }
          .ttshop_accounnext {
            width: 100%;
            height: 40px;
            background: linear-gradient(90deg, #ff9010, #ff0e25);
            background: -moz-linear-gradient(90deg, #ff9010, #ff0e25);
            background: -webkit-gradient(90deg, #ff9010, #ff0e25);
            background: -ms-linear-gradient(90deg, #ff9010, #ff0e25);
            filter: progid:DXImageTransform.Microsoft.gradient(GradientType=1, startColorstr=#FF9010, endColorstr=#FF0E25);
            font-size: 14px;
            color: #fff;
            border: 0;
            border-radius: 2px;
            cursor: pointer;
            outline: none;
            transition: 0.5s;
            -moz-transition: 0.5s;
            -webkit-transition: 0.5s;
            -o-transition: 0.5s;
            opacity: 0.8;
            &:hover {
              opacity: 1;
              box-shadow: 0 0 10px rgba(255, 14, 37, 0.3);
            }
          }
          .ttshop_email {
            display: table;
            font-size: 12px;
            color: #333;
            transition: 0.5s;
            -moz-transition: 0.5s;
            -webkit-transition: 0.5s;
            -o-transition: 0.5s;
            cursor: pointer;
            &:hover {
              color: #ff0e25;
            }
          }
        }
      }
    }
    .ttshop_accounconed {
      width: 420px;
      margin: 0 auto;
      padding-top: 90px;
      box-sizing: border-box;
      ul {
        li {
          width: 100%;
          margin-bottom: 20px;
          p {
            float: left;
            width: 80px;
            text-align: right;
            font-size: 12px;
            color: #333;
          }
          .ttshop_accountext {
            line-height: 40px;
          }
          span {
            float: left;
            font-size: 12px;
            color: #333;
          }
          input {
            float: left;
            width: 340px;
            height: 40px;
            border: 1px solid #ebebeb;
            outline: none;
            padding: 0 12px;
            box-sizing: border-box;
            font-size: 12px;
            color: #333;
            border-radius: 2px;
            margin-bottom: 20px;
            transition: 0.5s;
            -moz-transition: 0.5s;
            -webkit-transition: 0.5s;
            -o-transition: 0.5s;
            &:focus {
              border-color: #ff0e25;
            }
          }
          .ttshop_accounnext {
            float: right;
            width: 340px;
            height: 40px;
            background: linear-gradient(90deg, #ff9010, #ff0e25);
            background: -moz-linear-gradient(90deg, #ff9010, #ff0e25);
            background: -webkit-gradient(90deg, #ff9010, #ff0e25);
            background: -ms-linear-gradient(90deg, #ff9010, #ff0e25);
            filter: progid:DXImageTransform.Microsoft.gradient(GradientType=1, startColorstr=#FF9010, endColorstr=#FF0E25);
            font-size: 14px;
            color: #fff;
            border: 0;
            border-radius: 2px;
            cursor: pointer;
            outline: none;
            transition: 0.5s;
            -moz-transition: 0.5s;
            -webkit-transition: 0.5s;
            -o-transition: 0.5s;
            opacity: 0.8;
            &:hover {
              opacity: 1;
              box-shadow: 0 0 10px rgba(255, 14, 37, 0.3);
            }
          }
          .ttshop_email {
            display: table;
            font-size: 12px;
            color: #333;
            transition: 0.5s;
            -moz-transition: 0.5s;
            -webkit-transition: 0.5s;
            -o-transition: 0.5s;
            cursor: pointer;
            &:hover {
              color: #ff0e25;
            }
          }
        }
      }
    }
  }
  .ttshop_accounseccess {
    width: 380px;
    margin: 0 auto;
    padding-top: 90px;
    box-sizing: border-box;
    .ttshop_accounseccessimg {
      width: 100px;
      height: 100px;
      border-radius: 50%;
      margin: 0 auto 24px;
      img {
        display: block;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        object-fit: cover;
      }
    }
    span {
      display: block;
      font-size: 12px;
      color: #333;
      font-weight: 400;
      margin-bottom: 30px;
      text-align: center;
    }
    p {
      text-align: center;
      font-size: 12px;
      color: #0e9cff;
      display: block;
      cursor: pointer;
      transition: 0.5s;
      -moz-transition: 0.5s;
      -webkit-transition: 0.5s;
      -o-transition: 0.5s;
      opacity: 0.7;
      &:hover {
        opacity: 1;
      }
    }
  }
}

.ttshop_mobileyz {
  padding-right: 110px;
  background: url(../../assets/images/ttshop_yz.png) 11px center no-repeat;
}

.ttshop_password {
  background: url(../../assets/images/ttshop_password.png) 11px center no-repeat;
}

.ttshop_yzm {
  // display: block;
  min-width: 98px;
  height: 38px;
  border: 0;
  outline: none;
  font-size: 12px;
  color: #333;
  border: 0;
  background: #eeeeee;
  position: absolute;
  top: 1px;
  right: 1px;
  border-radius: 0 2px 2px 0;
  cursor: pointer;
}
</style>
